import timestamp from './timestamp.js'
import date from './date.js'
import deviceInfo from './test.mobile.js'

export default {
  timestamp,
  date,
  deviceInfo,

  /**
   * 生成随即 UUID
   */
  uuid () {
    const tempUrl = URL.createObjectURL(new Blob())
    const id = tempUrl.toString() // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
    URL.revokeObjectURL(tempUrl)
    return id.substring(id.lastIndexOf('/') + 1).replace(/-/g, '')
  },

  /**
   * 生成随即 ID
   */
  guid () {
    return '_xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let r = Math.random() * 16 | 0
      let v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    }).toLowerCase()
  },

  /**
   * 获取 dom offset
   */
  offset (dom) {
    let res = {
      left: dom.offsetLeft || 0,
      top: dom.offsetTop || 0
    }

    let parent = dom.offsetParent

    while (parent) {
      res.left += parent.offsetLeft
      res.top += parent.offsetTop
      parent = parent.offsetParent
    }

    res.right = res.left + dom.offsetWidth
    res.bottom = res.top + dom.offsetHeight

    res.width = dom.offsetWidth
    res.height = dom.offsetHeight

    return res
  },
  /**
   * 节流函数
   * @param {Function} callback 执行函数
   * @param {Number}   time     间隔时间
   */
  throttle (callback, time = 60) {
    let running = false

    return () => {
      if (running) return

      running = true

      setTimeout(() => {
        callback()
        running = false
      }, time)
    }
  },
  /**
   * 截取指定长度的字符串
   *
   * 该截取方法区分全半角字符，需要将全角字符的长度 x2
   *
   * @param    {string}  str 要截取的字符串
   * @param    {number}  len 要截取的字符串长度
   * @return   {string}      截取完毕的字符串
   */
  subString (str, len, dot) {
    let str2 = str.slice(0, len)
    let i = str2.replace(/[x00-xff]/g, '').length
    let strDot = dot && str.length > len / 2 ? '...' : ''

    switch (i) {
      // 全是英文或者数字
      case 0: return str2 + strDot
      case len: return str.slice(0, len >> 1) + strDot
      default:
        let k = len - i
        let str3 = str.slice(k, len)
        let j = str3.replace(/[x00-xff]/g, '').length
        return (j ? str.slice(0, k) + this.subString(str3, j) : str.slice(0, k)) + strDot
    }
  },
  /**
   * 获取滑动的方向
   * @param {Number} startx 滑动坐标
   * @param {Number} starty 滑动坐标
   * @param {Number} endx   滑动坐标
   * @param {Number} endy   滑动坐标
   * @return result [0:未滑动,1:向上,2:向下,3:向左,4:向右]
   */
  getTouchDirection (startx, starty, endx, endy) {
    let result = 0
    const angx = endx - startx
    const angy = endy - starty

    // 如果滑动距离太短
    if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
      return result
    }

    const angle = Math.atan2(angy, angx) * 180 / Math.PI

    if (angle >= -135 && angle <= -45) {
      result = 1
    } else if (angle > 45 && angle < 135) {
      result = 2
    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
      result = 3
    } else if (angle >= -45 && angle <= 45) {
      result = 4
    }

    return result
  },
  disableBodyScroll: (() => {
    const preventDefault = (event) => {
      event.preventDefault()
    }

    return {
      on () {
        document.body.addEventListener('touchmove', preventDefault, {
          passive: false
        })
      },
      off () {
        document.body.removeEventListener('touchmove', preventDefault, {
          passive: false
        })
      }
    }
  })(),
  fixedBody: ((className) => {
    var scrollTop = 0
    var bodyTop = 0

    return {
      open () {
        scrollTop = document.scrollingElement.scrollTop || document.body.scrollTop
        document.body.style.top = -scrollTop + 'px'
        document.body.classList.add(className)
        bodyTop = document.body.style.top
      },
      close () {
        document.body.classList.remove(className)
        document.scrollingElement.scrollTop = scrollTop
        document.body.scrollTop = scrollTop
        document.body.style.top = bodyTop
      }
    }
  })('fixed'),
  /**
   * 给 url 增加指定的参数，如果 url 中有该参数则替换
   *
   * @param    {string}  url 要加参数的 url
   * @param    {string}  key 要增加的参数名
   * @param    {string}  val 要增加的参数值
   * @param    {boolean}  encode 是否要对该地址 encodeURIComponent
   * @return   {string}      处理完的 url
   */
  addUrlParam: (url, key, val, encode = true) => {
    const newParam = key + '=' + (encode ? encodeURIComponent(val) : val)
    let params = '?' + newParam
    // If the 'url' string exists, then build params from it
    if (url) {
      // Try to replace an existance instance
      params = url.replace(
        new RegExp('([?&])' + key + '[^&]*'),
        '$1' + newParam
      )
      // If nothing was replaced, then add the new param to the end
      if (params === url && url.indexOf(newParam) < 0) {
        params += (url.indexOf('?') > 0 ? '&' : '?') + newParam
      }
    }
    return params
  },

  /**
   * 给 url 增加指定的参数，如果 url 中有该参数则替换
   *
   * @param   {String}        url             要加参数的 url
   * @param   {Object|Array<Object>}  params  要增加的参数集合
   * @param   {String}        params.key      要增加的参数名
   * @param   {String}        params.value    要增加的参数值
   * @param   {Boolean}       [encode=true]   是否要对该地址 encodeURIComponent
   * @return  {String}        处理完的 url
   */
  addUrlParams (url, params, encode = true) {
    let [_url, search = ''] = url.split('?')
    let hash = {}
    const result = []

    // 如果 params 是数组的情况
    if (Array.isArray(params)) {
      params.forEach(item => {
        // 单项为 xxx=xx 这样的时候
        if (typeof item === 'string') {
          search += `&${item}`
        }

        // 单项为 {key, value} 的情况
        if (this.isObject(item)) {
          search += `&${item.key}${item.value === undefined ? '' : '=' + item.value}`
        }
      })
    }

    // 把原先 url 中的 hash 先提取出来
    search.replace(/(?<key>[^=&]+)(=?(?<value>[^=&]+))*/g, ($0, $1, $2, $3) => {
      hash[$1] = $3
    })

    // 如果 params 是 Object 则直接浅拷贝一下
    if (this.isObject(params)) {
      hash = {...hash, ...params}
    }

    Object.keys(hash).forEach(key => {
      result.push(`${key}${hash[key] === undefined ? '' : '=' + (encode ? encodeURIComponent(hash[key]) : hash[key])}`)
    })

    return `${_url}?${result.join('&')}`
  },

  /**
   * 判断是否为 Promise 对象
   * @param {Any}  value  参考值
   * @return 是否为 Promise 对象
   */
  isPromise (value) {
    return value && Object.prototype.toString.call(value) === '[object Promise]'
  },

  /**
   * 判断是否为正则表达式
   * @param {Any}  value  参考值
   * @return 是否为正则表达式
   */
  isRegExp (value) {
    return value && Object.prototype.toString.call(value) === '[object RegExp]'
  },

  /**
   * 伪强等判断
   * 把对比值转为 字符串判断是否相等，主要是转化数字型参数
   * @param {String|Number} value     参考值
   * @param {String|Number} contrast  对比值
   * @return 判断两个值在转为 String 型后是否相等
   */
  isEqual (value, contrast) {
    // console.log('value', typeof value, value)
    // console.log('contrast', typeof contrast, contrast)
    // console.log('isEqual Result', value + '' === contrast + '')

    // 数字型的判断方式，主要是为了处理前位补零的数字型字符串，中间插入空格防止空字符串的误判
    if (/^\d+\s\d+$/.test(`${value} ${contrast}`)) {
      return !(value - contrast)
    }

    return value + '' === contrast + ''
  },

  /**
   * 判断值是否是 Function
   */
  isFunction (value) {
    return typeof value === 'function'
  },

  /**
   * 判断值是否是对象
   */
  isObject (value) {
    return value && Object.prototype.toString.call(value) === '[object Object]'
  }
}
